import { forwardRef, InputHTMLAttributes, useEffect, useRef } from 'react'

interface TableCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    indeterminate?: boolean
}

const TableCheckbox = forwardRef<HTMLInputElement, TableCheckboxProps>(({ indeterminate, ...rest }, ref) => {
    const defaultRef = useRef<HTMLInputElement>(null)
    const resolvedRef = ref || defaultRef

    useEffect(() => {
        if (resolvedRef && 'current' in resolvedRef && resolvedRef.current) {
            resolvedRef.current.indeterminate = !!indeterminate
        }
    }, [resolvedRef, indeterminate])

    return <input className="form-check-input" type="checkbox" ref={resolvedRef} {...rest} />
})

TableCheckbox.displayName = 'TableCheckbox'

export default TableCheckbox
